<template>
  <div>
    <account-form
      v-if="account && customer"
      :account="account"
      @submit="onSubmit"
      :loading="loading"
      :mode="mode"
      :customer="customer"></account-form>
  </div>
</template>

<script>
import AccountForm from './AccountForm'
import {customerService} from "@/services/CustomerService.class";
import {adminAccountService} from "@/services/AdminAccountService.class";

export default {
  name: "CreateAccount",
  components: {AccountForm},
  data() {
    return {
      customer: null,
      account: null,
      loading: false,
      mode: 'create',
    }
  },
  mounted() {
    if (this.$route.params.accountId) {
      adminAccountService.getAccountById(this.$route.params.accountId).then((result) => {
        this.account = result.data;
      });
      this.mode = 'edit'
    } else {
      this.account = {};
    }
    customerService.getById(this.$route.params.id).then((result) => {
      this.customer = result.data;
    });
  },
  methods: {
    onSubmit(account) {
      this.loading = true;
      if (this.mode === 'create') {
        customerService.addAccount(this.customer.id, account).then(() => {
          this.$message.success(this.$t('settings.accountCreated'));
          this.$router.back();
        }).catch(() => {
          this.$message.error(this.$t('settings.accountCreateError'));
        })
          .finally(() => this.loading = false);
      } else {
        adminAccountService.updateAccount(account.id, account).then(() => {
          this.$message.success(this.$t('settings.accountUpdated'));
          this.$router.back();
        }).finally(() => this.loading = false);
      }
    }
  }
}
</script>

<style scoped>

</style>
